// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function bookingWidgetMobileFuntionality(){
	let buttonTrigger = document.getElementById(`BW-mobile`),
		bookingContainer = document.getElementById(`booking`),
		closeText = {
			'es': 'CERRAR',
			'en': 'CLOSE'
		};
		console.log (buttonTrigger)
		console.log (bookingContainer)

	buttonTrigger.addEventListener( 'click', event => {
		event.preventDefault();
		buttonTrigger.classList.toggle('activated');
		bookingContainer.classList.toggle('opened');

		if( buttonTrigger.classList.contains('activated') )
			buttonTrigger.textContent = closeText[lang];
		else
			buttonTrigger.textContent = buttonTrigger.dataset.original_text;
	} );
}

function bookingWidgetInputFunctionality(){

	let propertySelectorOnBW = document.querySelector(`select#property`),
		inputHiddenForPropertyCode = document.querySelector(`input#propertyCode`);
	
	if( propertySelectorOnBW && inputHiddenForPropertyCode ){
		propertySelectorOnBW.addEventListener('change', () => {
			inputHiddenForPropertyCode.value = propertySelectorOnBW.value
		})
	}

	let use_points_checkbox = document.getElementById('useRewardsPoints');
	if( use_points_checkbox ){
		use_points_checkbox.addEventListener( 'click', () => {
			if( use_points_checkbox.checked == true ){
				use_points_checkbox.value = 'true';
			}else{
				use_points_checkbox.value = 'false';
			}
		} );
	}

	let clusterCode_home = document.getElementById('clusterCode'),
		corporateCode_home = document.getElementById('corporateCode');

	if( clusterCode_home && corporateCode_home ){
		corporateCode_home.addEventListener( 'keyup', () => {
			if( corporateCode_home.value.length > 0 ){
				clusterCode_home.removeAttribute('disabled');
			}else{
				clusterCode_home.setAttribute('disabled', 'true');
			}
		} );
	}

}

function openAndChangeLang(){
	const 	BUTTON_OPEN_LIST = document.querySelector(`#label-trigger-lang-options`),
			LIST_LANG = document.querySelector(`#list-options-languages`);

	BUTTON_OPEN_LIST.addEventListener( 'click', () => {
		LIST_LANG.classList.toggle('open')
	} );

	LIST_LANG.addEventListener( 'click', (e) => {
		let element_clicked = e.target;
		if( element_clicked.nodeName == 'LI' ){
			changeLanguage(element_clicked.dataset.lang);
		}
	} );
}

(function(){

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	flatpickr('#CheckInOut', {
		minDate: "today",
		dateFormat: "m/d/Y",
		mode: "range",
		onChange: function(selectedDates, dateStr, instance) {
			/* To change change the 'TO' between the dates for '-' */
			if (selectedDates.length === 2) {
				const start = instance.formatDate(selectedDates[0], "m/d/Y");
				const end = instance.formatDate(selectedDates[1], "m/d/Y");
				instance.input.value = `${start} - ${end}`;
				document.querySelector(`input[name="fromDate"]`).value = start
				document.querySelector(`input[name="toDate"]`).value = end
			}
		}
	})

	bookingWidgetMobileFuntionality();

	bookingWidgetInputFunctionality();

	openAndChangeLang();

})();


document.addEventListener("DOMContentLoaded", function () {
    
    const footer = document.querySelector('.footer');
    if (!footer) return;

    
    const container = footer.querySelector('[role="region"]');
    if (!container) return;

    const nuevoBoton = document.createElement('a');
	
    nuevoBoton.href = site_url+'sitemap';
    nuevoBoton.setAttribute('aria-label', 'SiteMap');
    nuevoBoton.textContent = 'SiteMap';

    container.appendChild(document.createTextNode(' '));
    container.appendChild(nuevoBoton);
});